import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Optional, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '../../../_infrastructure/TableEdit/TableEditBase';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponent } from '../../ICardComponent';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import DateHelpers from '../../../_infrastructure/DateHelpers';
import { Subscription } from 'rxjs';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { UtilsService } from '../../../_infrastructure/Utils/UtilsService';

@Component({
    selector: 'remuneration-other-table-edit',
    templateUrl: './remuneration-other-table-edit.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class RemunerationOtherTableEditComponent extends TableEditBase<models.RemunerationOtherVM> implements OnInit, OnDestroy {

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];

  //These dates are pending functional validation, should be receiveid as inputs or colected elsewhere
  public minDate: Date;
  public maxDate: Date;
  //Usado para display condicional de tooltips consoante o componente pai do edit caso este edit no futuro seja partilhado por mais de 2 compoenntes terá de ser revisto
  public isParentCurrentMonthly = false;
  public last24Months = [];
  public last24MonthsBefore2005End = [];
  public selectedSuplement: {};
  public suplements: {}[];
  public isTypeBRemunNonZero = false;
  public dataCessacao: any = null;
  public isExSubscritor: boolean = null;

  private mainSubscription: Subscription = new Subscription(); 

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute, @Optional() public parent: RemunerationOtherParent, private modalService: ModalService,
    private commonDataService: CommonDataService, private utilsService: UtilsService) {
    super(parent, modalService);
    this.isParentCurrentMonthly = (this.parent as ICardComponent).cardConfiguration.cardComponent == 'RemunerationsCurrentMonthlyComponent';
    const nullParent = this.parent as any;
    const workflowCode = nullParent.parentWorkflow.workflowInstance.workflowCode;
    this.isExSubscritor =  (workflowCode.indexOf('PEDI008') == -1 &&
                             workflowCode.indexOf('PEDI005') == -1) ? false : true;
    var haDataCessacao = nullParent.parentWorkflow?.workflowInstance?.formData?.StepSubscriberCGA?.CGAPensionStatus?.dataCessacao;

    if (workflowCode.indexOf('PEDI008B') != -1) {
      haDataCessacao = nullParent.parentWorkflow?.workflowInstance?.formData?.StepSubscriberInfo?.CGAPensionStatus?.dataCessacao;
    }

    if (haDataCessacao !== null && haDataCessacao !== undefined) {
      this.dataCessacao = new Date(haDataCessacao.getTime());
    }
    if (!this.isParentCurrentMonthly) {
      //this.maxDate = new Date(2005, 12, 31);
      this.maxDate = new Date("2005-12-31T00:00:00");
      this.last24MonthsBefore2005End = this.getLast24monthsBefore2005End();
    }
    else if (this.isParentCurrentMonthly) {
      this.maxDate = new Date();
      this.minDate = new Date(2006, 0, 1);
      this.last24Months = this.getLast24months();      
    }

    // resolve CommonData as of angular version 18 is broken
    const domainCodes: string[] = [
      DomainCodes.domains,
      DomainCodes.yesNo,
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domainCodes).subscribe(results => {
        this.domains = this.utilsService.getDomainOfDomains(DomainCodes.domains, results).dimensions;
        this.yesNo = this.utilsService.getDomainOfDomains(DomainCodes.yesNo, results).dimensions;
      })
    );


  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.isVersion2()) {
      this.anyMonthlyRemun();
    }
  }

  ngOnDestroy(): void {
    if (this.mainSubscription) {
      this.mainSubscription.unsubscribe();
    }
  }

  ngDoCheck(): void {
    if (this.isVersion2()) {
      if (isNullOrUndefined(this.suplements)) {
        this.getSuplements();
      }
    }
  }

  isVersion2() {
    let result = false;
    if (this.parent['parentWorkflow']?.['workflowVersion']?.toString() === '2') {
      result = true;
    }
    return result;
  }


  getSuplements() {
    let result = [];
    let maxStartDate: Date;
    let minEndDate: Date;
    if (this.parent['cardConfiguration']['cardCode'] !== 'RemunerationsCurrentMonthly') {
      maxStartDate = new Date("2005-12-31T23:59:59");
    } else {
      maxStartDate = new Date();
    }
    for (let i = 0; i < this.parent['workflowDropdowns'].options.length; i++) {
      if (this.parent['workflowDropdowns'].options[i]['dropdown'] === 'dropListSuplemento') {
        if (this.parent['cardConfiguration']['cardCode'] === 'RemunerationsCurrentMonthly') {
          if (this.parent['workflowDropdowns'].options[i]['filter2'] >= maxStartDate)
            result.push(this.parent['workflowDropdowns'].options[i]);
        } else {
          if (this.parent['workflowDropdowns'].options[i]['filter'] <= maxStartDate) {
            var suplDescs = result.map(function (a) { return a['value']; });
            if (suplDescs.indexOf(this.parent['workflowDropdowns'].options[i]['value']) < 0)
              result.push(this.parent['workflowDropdowns'].options[i]);
          }
        }
      }
    }
    this.suplements = result;
  }

  suplementChanged() {
    if (this.item.suplement !== undefined) {
      for (let i = 0; i < this.suplements.length; i++) {
        if (this.suplements[i]['value'] === this.item.suplement) {
          this.selectedSuplement = this.suplements[i];
          this.item.suplementDescription = this.suplements[i]['description'];
          if (this.selectedSuplement['type'] !== undefined && this.selectedSuplement['type'] !== "")
            this.item.renumerationType = this.selectedSuplement['type'];
          else
            this.item.renumerationType = undefined;

          if (this.parent['cardConfiguration']['cardCode'] !== 'RemunerationsCurrentMonthly') {
            if (this.item.renumerationType === 'A' || this.item.renumerationType === 'O') {
              this.item.startDate = new Date("2005-12-01T00:00:00");
            } else {
              this.item.startDate = undefined;
            }
          }
        }
      }
      this.renumerationTypeChanged();
    } else {
      this.selectedSuplement = undefined;
      this.item.suplementDescription = undefined;
      this.item.renumerationType = undefined;
      this.item.numberOfSemesters = undefined;
    }
  }

  getRenumerationTypes() {
    let result = [];
    for (let i = 0; i < this.parent['workflowDropdowns'].options.length; i++) {
      if (this.parent['workflowDropdowns'].options[i]['dropdown'] === 'dropListTipoRemun') {
        if (this.item.suplement === 'OUTR' && this.parent['workflowDropdowns'].options[i].value == 'O') {
          continue;
        } else {
          result.push(this.parent['workflowDropdowns'].options[i]);
        }
      }
    }
    return result;
  }

  renumerationTypeChanged() {
    if (this.parent['cardConfiguration']['cardCode'] === 'RemunerationsCurrentMonthly') {
      let rightNow = new Date (new Date(Date.now()).setDate(1));
      if (this.item.renumerationType !== 'B') {
        // Se for exsubscritor a data a ter em conta é a data de cessacão
        if (this.isExSubscritor){            
            if(!!this.dataCessacao){
              this.item.startDate = new Date(this.dataCessacao.setDate(1));
            }
        } else {
          this.item.startDate = rightNow;
        }
      } else {
        if (this.isExSubscritor) {
          if (!!this.dataCessacao) {
            const data2 = new Date(this.dataCessacao.getTime());
            this.item.startDate = new Date(new Date(data2.setFullYear(data2.getFullYear() - 2)).setDate(1));
          }
        } else {
          rightNow = new Date(new Date(rightNow.setFullYear(rightNow.getFullYear() - 2)).setDate(1));
          this.item.startDate = rightNow;
        }
      }
    }

    if (this.parent['cardConfiguration']['cardCode'] === 'RemunerationsLastUntilCutoff') {
      if (this.item.renumerationType !== 'B') {
        this.item.startDate = new Date("2005-12-01T00:00:00");
      } else {
        this.item.startDate = undefined;
      }
    }
  }

  getLast24months() {
    let last24Months = [];
    var monthName = new Array("Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro");
    var d = this.isExSubscritor ? new Date(this.dataCessacao.getTime()) :  new Date();
    d.setMonth(d.getMonth() - 1);
    d.setDate(1);
    for (let i = 0; i <= 23; i++) {
      last24Months.push(monthName[d.getMonth()] + ' ' + d.getFullYear());
      d.setMonth(d.getMonth() - 1);
    }
    last24Months.reverse();
    return last24Months;
  }

  getLast24monthsBefore2005End() {
    let last24Months = [];
    var monthName = new Array("Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro");
    var d = new Date("2005-12-31T00:00:00")
    d.setDate(1);
    for (let i = 0; i <= 23; i++) {
      last24Months.push(monthName[d.getMonth()] + ' ' + d.getFullYear());
      d.setMonth(d.getMonth() - 1);
    }
    last24Months.reverse();
    return last24Months;
  }

  onEdit(isEdit: boolean) {
    super.markTouched();
    if (this.isVersion2()) {
      let sValue;

      sValue = this.item.remunerationValue;
      if (sValue !== undefined) {
        sValue = sValue.replace(/\,/g, ".").replace(/\ /g, "");
        this.item.remunerationValue = sValue;
      }

      if (this.item.renumerationType !== 'B' && this.item.numberOfSemesters < 1 && this.tableItemEditForm.valid) {
        var baseModal = <models.BaseModalVM>{ isError: false, message: "O Nº de semestres deve ser maior que 0." };
        this.modalService.showModals([baseModal]).subscribe(result => {
          if (result)
            return;
        });
      } else if (this.item.renumerationType === 'B' && this.isTypeBRemunNonZero === false) {
        return;
      } else
        super.onEdit(isEdit);

    } else {
      super.onEdit(isEdit);
    }
  }

  getEffMap2005Renumeration() {
    let result;

    let effMapEntries: models.EffectivityEntryVM[] = this.parent['parentWorkflow']?.['workflowInstance']?.['formData']?.['StepMap']?.['EffectivityMap']?.['effectivityList'];
    //result = effMapEntries[effMapEntries.length - 1]
    for (let i = 0; i < effMapEntries.length; i++) {
      if (effMapEntries[i]['startDate'] <= this.maxDate)
        result = effMapEntries[i];
    }
    return result?.['value'];
  }

  getEffMapLastRenumeration() {
    let result;
    let effMapEntries: models.EffectivityEntryVM[] = this.parent['parentWorkflow']?.['workflowInstance']?.['formData']?.['StepMap']?.['EffectivityMap']?.['effectivityList'];

    return effMapEntries[effMapEntries.length - 1]?.['value'];
  }

  anyMonthlyRemun() {
    //let result;
    let result = Object.entries(this.item).find(function ([key, value]) {
      if (key.includes('month') && value !== undefined && value.replace(/\,/g, ".").replace(/\ /g, "") > 0) {
        return true;
      }
    })

    if (result !== undefined) {
      this.isTypeBRemunNonZero = true;
    } else {
      this.isTypeBRemunNonZero = false;
    }
    //return result != undefined;
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    let object = new Date(this.item.startDate).toISOString().split('T')[0];
    DateHelpers.onDateChange(event, dp, object);
  }
}

export abstract class RemunerationOtherParent{ };
